/* 系统管理->资料库管理 */
<template>
  <div class="zlkgl">
    <div class="u-form">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          资料库管理
        </h4>
      </template>
      <car-form @submit="submit" :showformitem="formitem">
        <template>
          <el-button type="success" size="small" @click="add(true)"
            >新建分类</el-button
          >
          <el-button type="success" size="small" @click="add(false)"
            >新建资料</el-button
          >
        </template>
      </car-form>
    </div>
    <div class="main_show">
      <div class="show_class">
        <div class="title">资料分类</div>
        <div class="list">
          <el-menu @select="menuSelect">
            <el-menu-item
              v-for="item in dataClass"
              :key="item.fileid"
              :index="item.fileid + ''"
            >
              <span slot="title">{{ item.filename }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="show_table">
        <hy-data-table
          v-model="loading"
          height="100%"
          ref="dataTable"
          @find-page="findPage"
          @detail-handle="detailHandle"
          @map-path="mapPath"
          @del="del"
          is-all-handle
          :data="dataTable.list"
          :columns="dataTable.columns"
          :extend-buttons="dataTable.buttons"
          :show-batch-delete="true"
          :show-operation="true"
          size="medium"
          :paging="dataTable.paging"
          :extend-but-widht="130"
        ></hy-data-table>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="zlkgl"
      :close-on-click-modal="false"
    >
      <el-form :model="classForm" v-if="dialogType">
        <el-form-item label="资料库名称">
          <el-input v-model="classForm.filename"></el-input>
        </el-form-item>
        <el-form-item label="资料库说明">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="classForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-form :model="dataForm" v-else>
        <el-form-item label="资料分类">
          <el-select v-model="dataForm.filepid" placeholder="请选择">
            <el-option
              v-for="item in dataClass"
              :key="item.fileid"
              :label="item.filename"
              :value="item.fileid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料名称">
          <el-input v-model="dataForm.filename"></el-input>
        </el-form-item>
        <el-form-item label="资料文件">
          <!-- <el-input v-model="dataForm.filepath"></el-input> -->
          <el-upload
            class="upload-demo"
            :action="'/api' + $apis.POST_uploadFile"
            :on-success="uploadSuccess"
            :limit="1"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>

        <!--  <el-form-item label="发布者">
          <el-input v-model="dataForm.uploadtor"></el-input>

        </el-form-item> -->
        <el-form-item label="资料说明">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="dataForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import carForm from "@/components/form/carForm.vue";
import hyDataTable from "@/components/HyDataTable.vue";
import { requireJson, getdict } from "@/commons/util.js";
import webConfig from "@/web.config.js";
import { watch } from "fs";
export default {
  components: {
    carForm,
    hyDataTable
  },
  data() {
    return {
      dialogVisible: false, //增加修改分类资料弹窗
      dialogType: true, //区分操作的是分类还是资料，分类为true,资料为false
      submitType: true, //区分请求的是增加还是修改，增加为true,修改为false
      dialogTitle: "", //弹窗标题
      form: {},
      classForm: {}, //分类表单
      dataForm: {}, //资料表单
      fileList: [],
      dataClass: [],
      height: "",
      formitem: [
        "filename", //资料名称
        "issuetime" //发布时间
      ],
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: "filepid", label: "资料分类", minWidth: 90 },
          { prop: "filename", label: "资料名称", minWidth: 120 },
          { prop: "remark", label: "资料描述", minWidth: 150 },
          { prop: "uploadtime", label: "发布时间", minWidth: 120 },
          { prop: "uploadtor", label: "发布者", minWidth: 60 },
          { prop: "downloadcount", label: "下载次数", minWidth: 60 }
        ],
        buttons: [
          {
            label: "下载",
            click: "map-path",
            perms: 100102,
            // icon: 'fa fa-picture-o',

            type: "info"
          },
          {
            label: "修改",
            click: "detail-handle",
            perms: 100103,
            // icon: 'fa fa-picture-o',

            type: "primary"
          },

          {
            label: "删除",
            click: "del",
            perms: 100102,
            // icon: 'fa fa-picture-o',

            type: "error"
          }
        ],
        paging: {
          pageIndex: 1, // 表格分页信息
          pageRow: 10,
          total: 0
        }
      }
    };
  },
  methods: {
    //菜单切换选择
    menuSelect(index, indexPath) {
      //console.log('菜单',index,indexPath)
      this.form.filepid = parseInt(index);

      this.getData();
    },
    submit(form) {
      console.log("提交表单", form);
      this.form.filename = form.filename;
      this.form.beginTime = form.issuetime ? form.issuetime[0] : "";
      this.form.endTime = form.issuetime ? form.issuetime[1] : "";
      this.pageIndex = 1;
      this.dataTable.paging.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      //console.log("findPage", res1);
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    //添加
    add(type) {
      this.dialogVisible = true;
      this.submitType = true;
      this.dialogType = type;

      if (this.dialogType) {
        this.dialogTitle = "新建分类";
        this.classForm = {};
      } else {
        this.dialogTitle = "新增资料";
        this.dataForm = {};
        this.$set(this.dataForm, "filepid", this.dataClass[0].fileid);
      }
      //console.log('添加',data)
    },
    //详情
    detailHandle(res) {
      this.dialogVisible = true;
      const data = res.row;
      this.dialogTitle = "修改资料";
      this.dialogType = false; //区分操作的是分类还是资料，分类为true,资料为false
      this.submitType = false; //区分请求的是增加还是修改，增加为true,修改为false
      console.log("aaaaaaa", data);
      this.dataForm = data;
      this.fileList = data.filepath ? [{ name: data.filepath, url: "" }] : [];
    },
    //新增修改分类，资料处理方法
    dialogSubmit() {
      switch (true) {
        case this.submitType && this.dialogType: //新增分类
          console.log("新增分类", this.classForm);
          this.$http.POST_addSort(this.classForm).then(res => {
            if (res.code == "00000") {
              this.$message.success("新增分类成功");
              this.dialogVisible = false;
              this.getCalss();
            } else {
              this.$message.error("新增分类失败" + res.msg);
            }
          });
          break;
        case this.submitType && !this.dialogType: //新增资料
          this.$http.POST_addFile(this.dataForm).then(res => {
            if (res.code == "00000") {
              this.$message.success("新增资料成功");
              this.dialogVisible = false;
              const filepid = this.form.filepid;
              this.form = {};
              this.form.filepid = filepid;
              this.pageIndex = 1;
              this.getData();
            } else {
              this.$message.error("新增资料失败" + res.msg);
            }
          });
          break;
        case !this.submitType && !this.dialogType:
          // console.log('修改资料',this.dataForm,this.dataClass);
          if (typeof this.dataForm.filepid !== "number") {
            for (let item of this.dataClass) {
              if (this.dataForm.filepid == item.filename) {
                this.dataForm.filepid = item.fileid;
                break;
              }
            }
          }
          //console.log(4444444,this.dataForm)
          delete this.dataForm.uploadtor;
          delete this.dataForm.uploadtime;
          this.$http.POST_fileUpdate(this.dataForm).then(res => {
            if (res.code == "00000") {
              this.$message.success("修改资料成功");
              this.dialogVisible = false;
              this.pageIndex = 1;
              this.getData();
            } else {
              this.$message.error("修改资料失败" + res.msg);
            }
          });
          break;
      }
    },

    uploadSuccess(response, file, fileList) {
      //console.log('上传文件',response,file,fileList)
      this.dataForm.filepath = response;
    },
    //下载方法
    mapPath(res1) {
      let baseURL = ""; // 使用代理
      if (res1.row.filepath == null || res1.row.filepath.length == 1) {
        this.$message.error("下载文件不存在");
        return;
      }
      //console.log("mapPath", res1.index,this.dataTable.list.data[res1.index].downloadcount);


      let num = res1.row.filepath.lastIndexOf(".");
      const str = res1.row.filepath.substr(num + 1);
      const id = res1.row.fileid;

      this.$axios({
        method: "get",
        headers: {
          "content-type": "application/json", // 默认值
          Authorization: "" //sessionStorage.getItem("access_token")
        },
        url:"/dqi-hymanage/hyDatafile/downloadFile/" + id,
        responseType: "blob"
      })
        .then(res=>{
          //console.log("aaaaa", res);
          this.dataTable.list.data[res1.index].downloadcount++
          let blob = new Blob([res]); // { type: "application/vnd.ms-excel" }
          let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象

          let a = document.createElement("a");
          a.href = url;
          a.download = res1.row.filename + "." + str;
          a.click();
          // 释放这个临时的对象url
          window.URL.revokeObjectURL(url);
        })
        .catch(function(res) {
          console.log("error", res);
        });
    },
    del(res1) {
      console.log("del", res1);
      const data = res1.row;
      this.$confirm('确定要删除吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$http.GET_delFile({ paramsID: "/" + data.fileid }).then(response => {
                this.$message.success("删除成功");
                console.log("删除接口结果", response);
                this.getData();
              });
            }).catch(() => {});
      
    },
    //数据列表
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;

      let arr = [];
      this.$http
        .POST_fileList(this.form)

        .then(response => {
          console.log("列表结果", response);
          this.dataTable.paging.total = response.total;
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].filepid = this.dictionaryChage(
                response.data[i].filepid,
                this.dataClass
              );
              arr.push(response.data[i]);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: []
          };
          this.$set(this.dataTable.list, "data", arr);
          //console.log('展示结果',this.dataTable.list)
        })

        .catch(error => {
          console.log(error);
        });
    },
    //列表字典转换处理
    dictionaryChage(val, option) {
      let data = "";
      for (let item of option) {
        if (item.fileid == val) {
          data = item.filename;
          break;
        } else {
          data = val;
        }
      }
      return data;
    },
    getCalss() {
      this.$http.GET_findSort().then(response => {
        console.log("资料库分类", response);
        this.$set(this, "dataClass", response.data);
      });
    }
  },
  mounted() {
    //this.getData()
  },
  created() {
    const obj = {};
    this.getCalss();
  },
  watch: {
    dialogVisible: function(newval, oldval) {
      if (!newval) this.fileList = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.main_show {
  width: 100%;
  height: 94%;
  display: flex;
  .show_class {
    width: 15%;
    background: #0d3a95;
    .el-menu-item {
      height: 26px;
      line-height: 26px;
       text-align: center;
    }
    .title {
      background-color: #307ac5;
      padding: 10px 0;
      font-weight: 800;
      color: #fff;
      font-size: 14px;
      text-align: center;
      height: 44px;
      line-height: 24px;
    }
    .list {
      .el-menu {
        border-right: none;
        background-color: transparent;
      }
      .el-menu-item {
        color: #fff;

      }
      .el-menu-item.is-active {
        color: #409eff;
        background-color: transparent;
      }
      .el-menu-item:focus,
      .el-menu-item:hover {
        background-color: transparent;
      }
    }
  }
  .show_table {
    width: 85%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/xtgl/zlkgl.vue